<template>
  <div class="container">
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="公司名称"
        v-model.trim="companyName"
        class="handle-input mr10"
      ></el-input>
      <el-select size="small" v-model="payType" @change="search" class="mr10">
        <el-option
          v-for="item in pay_type_options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        size="small"
        v-model="targetType"
        @change="search"
        class="mr10"
      >
        <el-option
          v-for="item in target_type_options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-date-picker
        size="small"
        class="mr10"
        v-model="startTime"
        type="date"
        @change="search"
        :editable="false"
        placeholder="开始时间"
        :disabledDate="startDisabledDate"
      >
      </el-date-picker>
      <el-date-picker
        size="small"
        v-model="endTime"
        type="date"
        @change="search"
        :editable="false"
        placeholder="结束时间"
        :disabledDate="endDisabledDate"
      >
      </el-date-picker>
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column width="220px" header-align="center" label="用户名称">
        <template #default="scope">
          <ul>
            <li>订单号：{{ scope.row.orderNo }}</li>
            <li>{{ scope.row.name }}</li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="用户类型"
        prop="invoice_type"
        :formatter="userTypeFilter"
      >
      </el-table-column>
      <el-table-column
        align="center"
        width="180px"
        label="订单名称"
        prop="targetName"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="realname"
        label="联系人"
      ></el-table-column>
      <el-table-column
        prop="username"
        label="联系电话"
        align="center"
      ></el-table-column>
      <el-table-column min-width="170" align="center" label="支付时间">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.payTime, "yyyy-MM-dd hh:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column min-width="100px" align="center" label="支付金额">
        <template #default="scope">{{ scope.row.price }}元 </template>
      </el-table-column>
      <el-table-column
        min-width="120px"
        prop="payTypes"
        align="center"
        label="支付方式"
        :formatter="payTypeFilter"
      >
      </el-table-column>

      <el-table-column label="开票状态" width="140" align="center">
        <template #default="scope">
          <span class="danger" v-if="scope.row.billingStatus === 0"
            >未开票</span
          >
          <span class="primary" v-if="scope.row.billingStatus === 1"
            >申请中</span
          >
          <el-button
            type="primary"
            size="mini"
            v-if="scope.row.billingStatus === 2"
            @click="confirmInvoicing(scope.row)"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>
    <!-- 开票详情 -->
    <el-dialog
      v-model="dialog"
      width="600px"
      title="纸质发票"
      destroy-on-close
      @close="close"
    >
      <div class="dialog-body">
        <el-form
          size="mini"
          ref="form"
          inline
          label-width="100px"
          label-position="right"
        >
          <h2>输入发票信息</h2>
          <div>
            <el-form-item label="发票代码：">
              <span>{{ form.invoiceCode }}</span>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="发票号码：">
              <span>{{ form.invoiceNumber }}</span>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="开票日期：">
              <span>{{
                $utils.formatDate(form.invoiceDate, "yyyy-MM-dd")
              }}</span>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="开票金额：">
              <span>{{ form.invoiceAmount }}</span>
            </el-form-item>
          </div>
          <div v-if="form.invoiceRemark">
            <el-form-item label="备注：">
              <p>{{ form.invoiceRemark }}</p>
            </el-form-item>
          </div>
          <h2>输入快递信息</h2>
          <div>
            <el-form-item label="快递名称：">
              <span>{{ form.expressName }}</span>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="快递单号：">
              <span>{{ form.expressNumber }}</span>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="发出日期：">
              <span>{{
                $utils.formatDate(form.expressDate, "yyyy-MM-dd")
              }}</span>
            </el-form-item>
          </div>
        </el-form>
        <h2>修改记录</h2>
        <el-table
          :data="listData.records"
          border
          class="table"
          key="list"
          header-cell-class-name="table-header"
        >
          <el-table-column align="center" label="修改时间">
            <template #default="scope">
              {{
                $utils.formatDate(scope.row.update_time, "yyyy-MM-dd hh:mm:ss")
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="修改者" prop="realname">
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="listData.current"
            :page-size="10"
            :total="listData.total"
            @current-change="getModifyRecord"
          ></el-pagination>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" size="mini" @click="dialog = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
var dayjs = require("dayjs");
export default {
  data() {
    return {
      data: {},
      companyName: "",
      payType: "",
      targetType: "",
      pay_type_options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "微信",
        },
        {
          value: 2,
          label: "支付宝",
        },
        {
          value: 3,
          label: "公户转账",
        },
      ],
      target_type_options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "个人",
        },
        {
          value: 2,
          label: "企业",
        },
        {
          value: 3,
          label: "团体",
        },
      ],

      startTime: "",
      endTime: "",

      dialog: false,
      itemData: {},
      form: {
        invoiceCode: "",
        invoiceNumber: "",
        invoiceDate: "",
        invoiceAmount: "",
        expressName: "",
        expressNumber: "",
        expressDate: "",
        invoiceRemark: "",
      },
      listData: {},
      loading: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    startDisabledDate(time) {
      if (!this.endTime) return false;
      time = new Date(time);
      var date = new Date(this.endTime);
      return time.getTime() > date.getTime();
    },
    endDisabledDate(time) {
      if (!this.startTime) return false;
      time = new Date(time);
      var date = new Date(this.startTime);
      return time.getTime() < date.getTime();
    },
    search() {
      console.log("123");
      this.getData();
    },
    async getData(page = 1) {
      if (this.companyName.length > 40) {
        this.$message.warning("搜索条件不能超过40个字");
        return;
      }
      try {
        const params = {
          payType: this.payType,
          targetType: this.targetType,
          startTime: this.startTime
            ? dayjs(this.startTime).format("YYYY-MM-DD")
            : null,
          endTime: this.endTime
            ? dayjs(this.endTime).format("YYYY-MM-DD")
            : null,
          name: this.companyName,
          currentPage: page,
          pageSize: 20,
        };
        this.$loading.start();
        const res = await this.$api.summary.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    async getModifyRecord(page = 1) {
      try {
        const params = {
          invoicingId: this.itemData.invoicingId,
          currentPage: page,
          pageSize: 10,
        };
        this.$loading.start();
        const res = await this.$api.invoice.completed.getModifyRecord(params);
        this.$loading.done();
        if (res.code === 10200) {
          console.log(123456);
          this.listData = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },

    async confirmInvoicing(data) {
      this.itemData = data;
      this.form = {
        invoiceCode: data.invoiceCode,
        invoiceNumber: data.invoiceNumber,
        invoiceDate: data.invoiceDate,
        invoiceAmount: data.invoiceAmount,
        expressName: data.expressName,
        expressNumber: data.expressNumber,
        expressDate: data.expressDeliveryTime,
        invoiceRemark: data.invoiceRemark,
      };
      await this.getModifyRecord();
      this.dialog = true;
    },
    userTypeFilter(row) {
      switch (row.targetType) {
        case 1:
          return "个人";
        case 2:
          return "企业";
        case 3:
          return "团体";
      }
    },
    payTypeFilter(data) {
      switch (data.payType) {
        case 0:
          return "套餐赠送";
        case 1:
          return "微信支付";
        case 2:
          return "支付宝支付";
        case 3:
          return "公户转账";
      }
    },

    close() {
      this.form = {
        invoiceCode: "",
        invoiceNumber: "",
        invoiceDate: "",
        invoiceAmount: "",
        expressName: "",
        expressNumber: "",
        expressDate: "",
      };
    },
  },
  watch: {
    status: {
      handler(val, ovl) {
        this.getData();
      },
    },
    companyName: {
      handler(val, ovl) {
        this.getData();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-box {
  margin-bottom: 20px;
  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .el-select {
    width: 120px;
  }
}

.danger {
  color: $--color-danger;
}

.primary {
  color: $--color-primary;
}

.invoicing_dialog-body {
  h2 {
    font-weight: 500;
    font-size: 1rem;
    margin-bottom: 10px;
  }

  table {
    width: 100%;
    margin-bottom: 10px;
    tr {
      td {
        padding: 10px;
        font-size: 0.875rem;
        border: 1px solid $--border-color-base;

        &:first-child {
          width: 120px;
          text-align: right;
          background-color: #f6f6f6;
        }
      }
    }
  }
}

.dialog-body {
  h2 {
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 12px;
    color: #333333;
  }

  p {
    width: 400px;
  }
}
</style>